const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ helpers
const { getLastNChars } = require('utilities/stringHelper');
const { mergeOrderAndId } = require('utilities/APIParsingHelper');
const { formatText } = require('core/i18n').i18n;
const classnames = require('classnames');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');
// @ constants
const { PLURAL_CHARACTER, VALID_STATUS_ECARD, PREPAID_CARD } = require('constants/index');
// @ components
const GlobalPositionFinancialCard = require('components/globalPosition/globalPositionFinancialCard/globalPositionFinancialCard');

class GlobalPositionECard extends React.Component {

    constructor(props) {
        super(props);
        this.handleBoxClick = this.handleBoxClick.bind(this);
    }

    getCurrencyDetail() {
        const { immCards } = this.props;

        if(__CONTACT_CENTER__) {
            return this.getCurrencyDetailForCC(immCards);
        } else {
            return this.getCurrentDetailForPrivate(immCards);
        }
    }

    getCurrentDetailForPrivate(immCards) {
        return immCards.getIn(['ecard', 'balanceDrawnForPG']).map(currencyContent => {
            return {
                currency: currencyContent.get('currency'),
                amount: currencyContent.get('amount'),
                legend: formatText('myGlobalPosition-balance')
            };
        }).toJS();
    }

    getCurrencyDetailForCC(immCards) {
        const immECards = this.mergeOrderAndIdCards(immCards);
        let amount = 0;
        let currency;

        immECards.filter(eCard => this.validStatusToBeShownInCC(eCard) ).toJS().forEach(filteredEcard =>{
            amount = amount + filteredEcard.availableBalance.amount;
            currency = filteredEcard.availableBalance.currency;
        });

        return [{
            currency: currency,
            amount: amount,
            legend: formatText('myGlobalPosition-balance')
        }];
    }

    validStatusToBeShownInCC = (eCard) => {
        return eCard.get('active') && eCard.get('statusCode') === VALID_STATUS_ECARD;
    }

    getECards() {
        const { immCards } = this.props;
        const immECards = this.mergeOrderAndIdCards(immCards);

        if(__CONTACT_CENTER__) {
            return this.getCardsForCC(immECards);
        } else {
            return this.getCardsForPrivate(immECards);
        }
    }

    mergeOrderAndIdCards(immCards) {
        return mergeOrderAndId(
            immCards.get('ecard').get('byOrder'),
            immCards.get('byId')
        );
    }

    getCardsForPrivate(immECards) {
        const validCards = immCard => {
            return immCard.get('filters').get('valid') && immCard.get('visibleinPG');
        };

        return immECards
            .filter(validCards)
            .map(immCard => this.prepareECardToBeShown(immCard))
            .toJS();
    }

    getCardsForCC(immECards) {
        return immECards.filter( eCard => this.validStatusToBeShownInCC(eCard) )
            .map( immCard => this.prepareECardToBeShown(immCard)).toJS();
    }

    prepareECardToBeShown(immECard) {
        return {
            title: immECard.get('alias').get('current'),
            titleSmall: getLastNChars(immECard.get('number'), 4),
            amount: immECard.get('balanceDrawn').get('amount'),
            currency: immECard.get('balanceDrawn').get('currency'),
            link: `/myprofile/cards/${immECard.get('cardId')}/movements`
        };
    }

    handleBoxClick(evt) {
        const linkToCardsView = '/myprofile/cards';
        const classListWithoutRedirect = [
            'ok-collapsing-toggler'
        ];
        if (!some(evt.target.parentElement.classList, (el) => includes(classListWithoutRedirect, el))) {
            this.props.history.push(linkToCardsView);
        }
    }

    render() {
        const {immCards, expanded, hasShowableECards} = this.props;
        const excludedItems = immCards.get('ecard') ? immCards.get('ecard').get('excludedCards') : 0;
        const pluralPostfix = excludedItems !== 1 ? PLURAL_CHARACTER : '';
        const subtitle =
            excludedItems > 0
                ? formatText('myGlobalPosition-excludedCards', [
                      excludedItems,
                      pluralPostfix,
                      pluralPostfix
                  ])
                : '';
        const currencyDetails = this.getCurrencyDetail();
        const eCards = this.getECards();
        const hasExcludedItems = (excludedItems > 0 && hasShowableECards);
        const allItemsExcluded = __CONTACT_CENTER__? false : (excludedItems > 0 && excludedItems === hasShowableECards);
        const financialCardClass = classnames({
            'global-position-accounts-section__subsection--is-clickable': !expanded
        });
        return (
            <div onClick={!expanded &&  this.handleBoxClick} className={financialCardClass}>
                <GlobalPositionFinancialCard
                    id={this.props.id}
                    icon="rebrand-ecard"
                    amount={eCards.length}
                    cards={eCards}
                    currencyDetails={currencyDetails}
                    showMoreText={formatText('myGlobalPosition-eCardShowMore')}
                    showMoreLink="/myprofile/cards" //TODO: TBD
                    title={formatText('myGlobalPosition-eCards')}
                    subtitle={subtitle}
                    expanded={expanded}
                    hasExcludedItems={hasExcludedItems}
                    allItemsExcluded={allItemsExcluded}
                    emptyStateMessage={formatText('myGlobalPosition-allECardsExcluded')}
                    titleLink="/myprofile/cards"
                    cardType={PREPAID_CARD}
                />
            </div>
        );
    }
}

GlobalPositionECard.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    hasShowableECards: PropTypes.bool.isRequired,
    id: PropTypes.string
};

module.exports = withRouter(GlobalPositionECard);
